export const ReviewProvider = {
    Title: 'Review Provider',
    SubTitles: {
        ShareLove: 'Share the Love',
        Compliment: 'Compliment'
    },
    Links: {
        SkipRating: {
            text: 'Skip Rating'
        }
    },
    Buttons: {
        Submit: {
            label: 'Submit'
        }
    },
    DropDowns: {
        Compliment: {
            placeholder: 'Give a compliment ...'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/ReviewProvider.ts